const icon = new URL('../../icons/visualizer.png', import.meta.url).href

export default {
  type: 'visualizer',
  description: '3D visualizer',
  group: 'warehouse' /* line|shape|textAndMedia|chartAndGauge|table|container|dataSource|IoT|3D|warehouse|form|etc */,
  icon,
  model: {
    type: 'visualizer',
    left: 100,
    top: 100,
    width: 800,
    height: 600,
    fillStyle: 'darkgray',
    fov: 60,
    near: 10,
    far: 10000,
    zoom: 100,
    threed: false
  }
}
